import api from './api';

export const getSystemStatus = () => api.get('/admin/system-status');

export const getErrors = (params = {}) => api.get('/admin/errors', { params });

export const getErrorStats = (days = 7) => api.get('/admin/errors/stats', { params: { days } });

export const resolveError = (id) => api.post(`/admin/errors/${id}/resolve`);

// User management
export const getUsers = (params = {}) => api.get('/admin/users', { params });

export const getUserDetail = (id) => api.get(`/admin/users/${id}`);

export const updateUser = (id, data) => api.patch(`/admin/users/${id}`, data);

export const toggleUserStatus = (id) => api.post(`/admin/users/${id}/toggle-status`);

export const deleteUser = (id) => api.delete(`/admin/users/${id}`);

// Global stats
export const getGlobalStats = () => api.get('/admin/stats');

// User approval
export const approveUser = (id) => api.post(`/admin/users/${id}/approve`);
export const rejectUser = (id) => api.post(`/admin/users/${id}/reject`);

// Opportunities management
export const toggleOpportunities = (id, action) => api.post(`/admin/users/${id}/opportunities-toggle`, { action });

// User insights
export const getUserActivity = (id, params = {}) => api.get(`/admin/users/${id}/activity`, { params });
export const getUserMetrics = (id) => api.get(`/admin/users/${id}/metrics`);
